import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filterBtn", "sortBtn", "card", "grid"]

  filter(event) {
    const filterType = event.currentTarget.dataset.filter

    // Update button styles
    this.filterBtnTargets.forEach(btn => {
      if (btn.dataset.filter === filterType) {
        btn.classList.remove("bg-gray-100", "text-gray-600", "hover:bg-gray-200")
        btn.classList.add("bg-primary-600", "text-white")
      } else {
        btn.classList.remove("bg-primary-600", "text-white")
        btn.classList.add("bg-gray-100", "text-gray-600", "hover:bg-gray-200")
      }
    })

    // Filter cards
    this.cardTargets.forEach(card => {
      if (filterType === "all" || card.dataset.kind === filterType) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })
  }

  sort(event) {
    const sortType = event.currentTarget.dataset.sort
    const dataKey = sortType === "updated_at" ? "updatedAt" : "createdAt"
    console.log("Sorting by:", sortType, "dataKey:", dataKey)

    // Update button styles
    this.sortBtnTargets.forEach(btn => {
      btn.classList.remove("bg-gray-100", "bg-gray-200", "text-gray-500", "text-gray-700", "hover:bg-gray-200")

      if (btn.dataset.sort === sortType) {
        btn.classList.add("bg-gray-200", "text-gray-700")
      } else {
        btn.classList.add("bg-gray-100", "text-gray-500", "hover:bg-gray-200")
      }
    })

    // Sort cards
    if (!this.hasGridTarget) {
      console.log("No grid target found")
      return
    }

    const grid = this.gridTarget
    const cards = [...this.cardTargets]
    console.log("Sorting", cards.length, "cards")

    cards.sort((a, b) => {
      return parseInt(b.dataset[dataKey]) - parseInt(a.dataset[dataKey])
    })

    cards.forEach(card => grid.appendChild(card))
    console.log("Sort complete")
  }
}
